import { usecreateNewObjectMutation } from 'pages/facilities/api/mutations/generated/CreateNewObject';
import { errorToast, successToast } from 'utils/helpers/notify';
import { CreateNewObjectInput } from 'generated/graphql';
import { useNavigate } from 'react-router-dom';
import { errorHandler } from 'utils/helpers/errorHandler';

export const useCreateObject = () => {
  const [createObjectMutation, { loading }] = usecreateNewObjectMutation();
  const navigate = useNavigate();

  const handleCreateObject = async (params: CreateNewObjectInput) => {
    await createObjectMutation({
      variables: {
        input: params,
      },
      context: {
        hasUpload: true,
      },
    })
      .then(res => {
        if (res.data?.createNewObject) {
          successToast('Объект успешно создан');
          navigate(`/facilities/${res.data.createNewObject.id}`);
        }
      })
      .catch(e => {
        errorToast(errorHandler(e));
      });
  };

  return { createObject: handleCreateObject, loading };
};
